import React, { Component } from "react";
import { injectIntl } from "react-intl";
import classNames from "classnames";

import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { documentActions, quoteActions } from "../../../../../../actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import config from "../../../../../../config/config";
import RenderFileOrUploader from "./RenderFileOrUploader";
import RenderMultipleFileUploader from "./RenderMultipleFileUploader";
import SimpleMessageDialog from "../../../../../../components/SimpleMessageDialog";
import CustomStep from "../../../../../../components/CustomStep";
import * as _ from "lodash";
import ENUMS from "../../../../../../utils/Enums";
import Util from "../../../../../../utils/Util";
import DropZone from "./DropZone";
import Esign from "./Esign";
import UEN from "./UEN";
import moment from "moment";
import {
  DOCUMENT_ACCEPTANCE_LETTER_UPLOAD,
  DOCUMENT_ACRA_UPLOAD,
  DOCUMENT_MAS314_UPLOAD,
  DOCUMENT_CORP_BANK_UPLOAD,
  DOCUMENT_DECLARATION_CLAIM_ENTITLEMENT_UPLOAD,
  DOCUMENT_NRIC_IND_UPLOAD
} from "../../../../../../actions/types";

//const eSignUnsupp = isDesktop && (isChrome || isFirefox);
const eSignUnsupp = false;

class SubmitDoc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      errors: {},
      showDialogError: false,
      dialogTitle: "",
      dialogDescription: "",
      // Pop-up A: YES/NO confirmation before upload/e-sign
      showPopupA: false,
      pendingAcceptanceFiles: null,
      pendingEsign: false,
      esignTriggerId: 0,
      showPopupAWarning: false,
      popupAWarningConfirmed: false,
      // Pop-up B: PED has passed, no proposal form uploaded
      showPopupB: false,
      popupBDismissed: false,
      // Pop-up C: PED has passed, proposal form uploaded
      showPopupC: false,
      popupCDismissed: false
    };
  }

  componentWillMount() {
    const { quote } = this.props;
    if (quote.id) this.props.documentActions.getFiles(quote.id);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.document.files !== nextProps.document.files) {
      this.setState({ files: nextProps.document.files });
    }
  }

  componentDidMount() {
    this.checkAndShowPopupBIfNeeded();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.document !== this.props.document ||
      prevProps.quote?.req_effective_date !== this.props.quote?.req_effective_date
    ) {
      this.checkAndShowPopupBIfNeeded();
    }
  }
  
  /**
   * Get Policy Effective Date from Redux store
   * Returns: { value: string (DD/MM/YYYY), isSelected: boolean }
   */
  getPolicyEffectiveDate = () => {
    const { quote } = this.props;
    const pedValue = quote && quote.req_effective_date;
    return {
      value: pedValue,
      isSelected: !Util.isEmpty(pedValue)
    };
  };

  /**
   * Check if Policy Effective Date has passed (before today)
   * Returns: boolean
   */
  isPolicyEffectiveDatePassed = () => {
    const { quote } = this.props;
    if (!quote || Util.isEmpty(quote.req_effective_date)) return false;
    
    const effectiveDate = moment(quote.req_effective_date, "DD/MM/YYYY").startOf("day");
    const today = moment().startOf("day");
    return effectiveDate.isBefore(today);
  };

  getFormattedPedDisplay = () => {
    const ped = this.getPolicyEffectiveDate();
    if (!ped.isSelected) {
      return "Not Selected";
    }
    return moment(ped.value, "DD/MM/YYYY").format("DD MMM YYYY");
  };

  checkAndShowPopupBIfNeeded = () => {
    const { document } = this.props;
    const acceptanceFiles = document && document.files && 
      document.files.filter(file => file.file_type === ENUMS.FILE_TYPE.ACCEPTANCE_FILE_TYPE);
    const hasProposal = acceptanceFiles && acceptanceFiles.length > 0;

    if (!this.isPolicyEffectiveDatePassed()) return;

    if (!hasProposal) {
      // If PED has passed, no proposal uploaded -> show Pop-up B
      if (!this.state.popupCDismissed && !this.state.popupBDismissed && !this.state.showPopupB) {
        this.setState({ showPopupB: true });
      }
      return;
    }

    // If PED has passed, proposal uploaded -> show Pop-up C
    if (!this.state.popupCDismissed && !this.state.showPopupC) {
      this.setState({ showPopupC: true });
    }
  };

  handleClose = () => {
    this.setState({ showDialogError: false });
  };


  /**
   * User clicks YES on popup A => allow upload/e-sign PF
   */
  handlePopupAYes = () => {
    const { pendingAcceptanceFiles, pendingEsign } = this.state;
    this.setState(prevState => ({ 
      showPopupA: false,
      pendingAcceptanceFiles: null,
      pendingEsign: false,
      esignTriggerId: pendingEsign ? prevState.esignTriggerId + 1 : prevState.esignTriggerId
    }), () => {
      if (pendingAcceptanceFiles && pendingAcceptanceFiles.length > 0) {
        this.handleUploadFile(
          DOCUMENT_ACCEPTANCE_LETTER_UPLOAD,
          ENUMS.FILE_TYPE.ACCEPTANCE_FILE_TYPE,
          pendingAcceptanceFiles
        );
      }
    });
  };

  /**
   * User clicks No on popup A => disable button and show warning popup 
   */
  handlePopupANo = () => {
    this.setState({ 
      showPopupA: false,
      showPopupAWarning: true,
      pendingAcceptanceFiles: null,
      pendingEsign: false
    });
  };

  /**
   * Dismiss the NO warning dialog
   */
  handlePopupAWarningDismiss = () => {
    this.setState({ showPopupAWarning: false });
  };

  handlePopupAWarningConfirm = () => {
    this.setState({ showPopupAWarning: false, popupAWarningConfirmed: true });
  };


  /**
   * User acknowledges Pop-up B (PED has passed)
   */
  handlePopupBDismiss = () => {
    this.setState({ 
      showPopupB: false,
      popupBDismissed: true
    });
  };

  /**
   * Dismiss Pop-up C
   */
  handlePopupCDismiss = () => {
    this.setState({ 
      showPopupC: false,
      popupCDismissed: true
    });
  };

  /**
   * Handle acceptance file upload with PED validation
   */
  handleAcceptanceUpload = (files) => {
    this.setState({ 
      showPopupA: true,
      pendingAcceptanceFiles: files,
      pendingEsign: false
    });
  };

  /**
   * Check if buttons should be disabled due to NO response
   */
  shouldDisableButtonsAfterNo = () => {
    return this.state.popupAWarningConfirmed;
  };

  /**
   * Check if buttons should be disabled due to PED passed, only disable if PED has passed
   */
  shouldDisableButtonsDueToPassedPed = () => {
    return this.isPolicyEffectiveDatePassed();
  };

  /**
   * Check file extension is valid or not
   * @return False if file is invalid. True if valid
   */
  invalidExtension = file => {
    let getExtension = file.name.split(".").pop();
    let arrayFileExtension = config.fileUploadOptions.accept.split(",").map(extension => {
      return extension.substr(1);
    });
    return arrayFileExtension.indexOf(getExtension) > 0;
  };

  getError = file => {
    const { intl } = this.props;

    if (file.size > config.fileUploadOptions.maxSize) {
      return {
        inValid: true,
        title: intl.formatMessage({ id: "popup.file.sizeExceeds.title" }),
        description: intl.formatMessage({
          id: "popup.file.sizeExceeds.description"
        })
      };
    }
    // else if (!this.invalidExtension(file)) {
    //   return {
    //     inValid: true,
    //     title: intl.formatMessage({ id: "popup.file.invalidExtension.title" }),
    //     description: intl.formatMessage({
    //       id: "popup.file.invalidExtension.description"
    //     })
    //   };
    // }
  };

  onDropRejected = (files, type) => {
    let firstFile = _.first(files);
    let errorData = this.getError(firstFile);
    if (errorData && errorData.inValid === true) {
      this.setState({
        errors: {
          [type]: {
            invalid: errorData.inValid,
            dialogTitle: errorData.title,
            dialogDescription: errorData.description
          }
        }
      });
    }
  };

  handleUploadFile = (uploadAction, fileType, files) => {
    const { errors } = this.state;
    Util.forEachAsync(files, file => {
      console.log("fileType", errors, fileType);
      this.props.documentActions.uploadFile(this.props.quote.id, uploadAction, fileType, file).then(
        () => {
          this.setState({
            errors: {
              ...errors,
              [fileType]: null
            }
          });
        },
        error => {
          if (DOCUMENT_ACCEPTANCE_LETTER_UPLOAD == uploadAction) {
            if(error.data.error =="PDF_UNSAFE_ERROR"){
              error.message = error.data.error_description;
            }else{
              error.message =
                "Invalid file format due to encrypted file. To unencrypt your file, you may refer to user guide under the Documents tab.";
            }
          } else if (error && error.data && error.data.error_description) {
            error.message = error.data.error_description;
          }

          this.setState({
            errors: {
              ...errors,
              [fileType]: {
                invalid: false,
                dialogTitle: "Upload error",
                dialogDescription: error.message
              }
            }
          });
        }
      );
    });
  };

  render() {
    const { classes, document, intl, quote, proposalDisabled } = this.props;
    const { files } = this.state;
    const ACCEPTANCE_FILE_TYPE = ENUMS.FILE_TYPE.ACCEPTANCE_FILE_TYPE;
    const ACRA_FILE_TYPE = ENUMS.FILE_TYPE.ACRA_FILE_TYPE;
    const MAS314_FILE_TYPE = ENUMS.FILE_TYPE.MAS314_FILE_TYPE;
    const CORP_BANK_FILE_TYPE = ENUMS.FILE_TYPE.CORP_BANK_DETAILS;
    const NRIC_IND_FILE_TYPE = ENUMS.FILE_TYPE.NRIC_IND_FILE_TYPE;
    const DECLARATION_CLAIM_ENTITLEMENT_FILE_TYPE = ENUMS.FILE_TYPE.DECLARATION_CLAIM_ENTITLEMENT_FILE_TYPE;
    const acceptanceLetterFiles = files.filter(file => file.file_type === ACCEPTANCE_FILE_TYPE) || [];
    const acraFiles = files.filter(file => file.file_type === ACRA_FILE_TYPE) || [];
    const mas314Files = files.filter(file => file.file_type === MAS314_FILE_TYPE) || [];
    const corpBankFiles = files.filter(file => file.file_type === CORP_BANK_FILE_TYPE) || [];
    const claimDeclarationFile = files.filter(file => file.file_type === DECLARATION_CLAIM_ENTITLEMENT_FILE_TYPE) || [];
    const NRIC_INDFiles = files.filter(file => file.file_type === NRIC_IND_FILE_TYPE) || [];

    let isPaid =
      quote.payment_method === ENUMS.PAYMENT_METHOD.CREDIT_CARD && quote.payment_status === ENUMS.PAYMENT_STATUS.DONE;
    let disabled = proposalDisabled || isPaid;

    const disableEsignAndUpload = this.shouldDisableButtonsDueToPassedPed();
    const disableDueToUserNo = this.shouldDisableButtonsAfterNo();

    return (
      <Grid container>
        <Grid item md={1} align="center">
          <CustomStep label="1" disabled={disabled} />
        </Grid>
        <Grid item md={11}>
          <Paper className={classNames(classes.root)} style={{ padding: "10px" }}>
            <div>
              <Typography variant="h5" gutterBottom className={classNames(classes.container, classes.heading)}>
                {intl.formatMessage({
                  id: "upload.signedProposalForm.subheading"
                })}
              </Typography>
              <div className={classNames(classes.content)}>
                <Grid item md={12}>
                  <Typography className={classNames(classes.infoHeading)}>
                    {intl.formatMessage({
                      id: "upload.signedProposalForm.infoheading.before"
                    })}
                  </Typography>
                </Grid>
                <Grid item md={12} style={{ marginBottom: "15px" }}>
                  <Typography className={classNames(classes.policyEffectiveDate)}>
                    {intl.formatMessage({
                      id: "upload.signedProposalForm.policyEffectiveDate"
                    }, { date: this.getFormattedPedDisplay() })}
                  </Typography>
                </Grid>
                <Grid item md={12}>
                  <Grid container className={classNames(classes.center)}>
                    <Grid item md={3} className={classNames(acceptanceLetterFiles.length > 0 ? classes.hidden : null)}>
                      <Esign 
                        disabled={disabled || disableEsignAndUpload || disableDueToUserNo} 
                        eSignUnsupp={eSignUnsupp}
                        onShowPopupA={() => this.setState({ showPopupA: true, pendingEsign: true })}
                        esignTriggerId={this.state.esignTriggerId}
                      />
                    </Grid>
                    <Grid
                      item
                      md={1}
                      align="center"
                      variant="dispay2"
                      className={classNames(acceptanceLetterFiles.length > 0 ? classes.hidden : null)}
                    >
                      <Typography>OR</Typography>
                    </Grid>
                    <Grid item md={8}>
                      <RenderFileOrUploader
                        disabled={isPaid}
                        files={acceptanceLetterFiles}
                        Uploader={
                          <DropZone
                            disabled={disabled || disableEsignAndUpload || disableDueToUserNo}
                            // accept={config.fileUploadOptions.accept}
                            maxSize={config.fileUploadOptions.maxSize}
                            descr={intl.formatMessage({
                              id: "upload.signedProposalForm.description"
                            })}
                            errorMessage={this.state.errors[ACCEPTANCE_FILE_TYPE]}
                            onDropRejected={files => {
                              this.onDropRejected(files, ACCEPTANCE_FILE_TYPE);
                            }}
                            onDropHandler={files => {
                              this.handleAcceptanceUpload(files);
                            }}
                            isUploading={this.props.document.acceptanceLetterIsUploading}
                          />
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Paper>
        </Grid>
        <Grid item md={1}>
          <CustomStep label="2" disabled={quote.readOnly || isPaid} />
        </Grid>
        <Grid item md={11}>
          <Paper className={classNames(classes.root)} style={{ padding: "10px", marginTop: "10px" }}>
            <div>
              <Typography variant="h5" gutterBottom className={classNames(classes.container, classes.heading)}>
                {intl.formatMessage({ id: "upload.documents.subheading" })}
              </Typography>
              <div className={classNames(classes.content)}>
                <Grid item md={12}>
                  <Typography className={classNames(classes.infoHeading)}>
                    {intl.formatMessage({ id: "validator.file.rules" })}
                  </Typography>
                </Grid>
                <Grid item md={12}>
                  {/*Upload ACRA Document Zone*/}
                  <RenderFileOrUploader
                    disabled={isPaid}
                    title={intl.formatMessage({ id: "upload.ACRA.title" })}
                    files={acraFiles}
                    Uploader={
                      <DropZone
                        // accept={config.fileUploadOptions.accept}
                        maxSize={config.fileUploadOptions.maxSize}
                        label={intl.formatMessage({ id: "upload.ACRA.title" })}
                        descr={intl.formatMessage({
                          id: "upload.ACRA.description"
                        })}
                        onDropRejected={files => {
                          this.onDropRejected(files, ACRA_FILE_TYPE);
                        }}
                        errorMessage={this.state.errors[ACRA_FILE_TYPE]}
                        onDropHandler={files => {
                          this.handleUploadFile(DOCUMENT_ACRA_UPLOAD, ACRA_FILE_TYPE, files);
                        }}
                        isUploading={this.props.document.acraIsUploading}
                      />
                    }
                  />
                </Grid>

                <Grid item md={6}>
                  <UEN />
                </Grid>

                <Grid item md={12}>
                  {/*Upload MAS314 Zone*/}
                  <RenderFileOrUploader
                    disabled={isPaid}
                    title={intl.formatMessage({ id: "upload.MAS314.title" })}
                    files={mas314Files}
                    Uploader={
                      <DropZone
                        // accept={config.fileUploadOptions.accept}
                        maxSize={config.fileUploadOptions.maxSize}
                        label={intl.formatMessage({
                          id: "upload.MAS314.title"
                        })}
                        descr={intl.formatMessage({
                          id: "upload.MAS314.description"
                        })}
                        onDropRejected={files => {
                          this.onDropRejected(files, MAS314_FILE_TYPE);
                        }}
                        errorMessage={this.state.errors[MAS314_FILE_TYPE]}
                        onDropHandler={files => {
                          this.handleUploadFile(DOCUMENT_MAS314_UPLOAD, MAS314_FILE_TYPE, files);
                        }}
                        isUploading={this.props.document.mas314IsUploading}
                      />
                    }
                  />
                </Grid>

                <Grid item md={12}>
                  {/*Upload Declaration of Entitlement to Claim Input Tax on Insurance Policy*/}
                  <RenderFileOrUploader
                    disabled={isPaid}
                    title={intl.formatMessage({ id: "upload.claim.tax.declaration.title" })}
                    files={claimDeclarationFile}
                    Uploader={
                      <DropZone
                        // accept={config.fileUploadOptions.accept}
                        disabled={quote.readOnly}
                        maxSize={config.fileUploadOptions.maxSize}
                        label={intl.formatMessage({
                          id: "upload.claim.tax.declaration.title"
                        })}
                        descr={intl.formatMessage({
                          id: "upload.claim.tax.declaration.description"
                        })}
                        onDropRejected={files => {
                          this.onDropRejected(files, DECLARATION_CLAIM_ENTITLEMENT_FILE_TYPE);
                        }}
                        errorMessage={this.state.errors[DECLARATION_CLAIM_ENTITLEMENT_FILE_TYPE]}
                        onDropHandler={files => {
                          this.handleUploadFile(
                            DOCUMENT_DECLARATION_CLAIM_ENTITLEMENT_UPLOAD,
                            DECLARATION_CLAIM_ENTITLEMENT_FILE_TYPE,
                            files
                          );
                        }}
                        isUploading={this.props.document.claimDeclarationIsUploading}
                      />
                    }
                  />
                </Grid>

                <Grid item md={12}>
                  {/*Upload NRIC_IND Zone*/}
                  <RenderMultipleFileUploader
                    disabled={quote.readOnly || isPaid}
                    title={intl.formatMessage({ id: "upload.NRIC_IND.title" })}
                    files={NRIC_INDFiles}
                    Uploader={
                      <DropZone
                        // accept={config.fileUploadOptions.accept}
                        maxSize={config.fileUploadOptions.maxSize}
                        descr={intl.formatMessage({
                          id: "upload.NRIC_IND.description"
                        })}
                        onDropRejected={files => {
                          this.onDropRejected(files, NRIC_IND_FILE_TYPE);
                        }}
                        errorMessage={this.state.errors[NRIC_IND_FILE_TYPE]}
                        onDropHandler={files => {
                          this.handleUploadFile(DOCUMENT_NRIC_IND_UPLOAD, NRIC_IND_FILE_TYPE, files);
                        }}
                        isUploading={this.props.document.NRIC_INDIsUploading}
                        multiple={true}
                      />
                    }
                  />
                </Grid>

                <Grid item md={12}>
                  {/*Uploadcorp bank details*/}
                  <RenderFileOrUploader
                    disabled={isPaid}
                    title={intl.formatMessage({ id: "upload.corpBank.title" })}
                    files={corpBankFiles}
                    Uploader={
                      <DropZone
                        // accept={config.fileUploadOptions.accept}
                        maxSize={config.fileUploadOptions.maxSize}
                        label={intl.formatMessage({
                          id: "upload.corpBank.title"
                        })}
                        descr={intl.formatMessage({
                          id: "upload.corpBank.description"
                        })}
                        onDropRejected={files => {
                          this.onDropRejected(files, CORP_BANK_FILE_TYPE);
                        }}
                        errorMessage={this.state.errors[CORP_BANK_FILE_TYPE]}
                        onDropHandler={files => {
                          this.handleUploadFile(DOCUMENT_CORP_BANK_UPLOAD, CORP_BANK_FILE_TYPE, files);
                        }}
                        isUploading={this.props.document.corpBankIsUploading}
                      />
                    }
                  />
                </Grid>
              </div>

              <SimpleMessageDialog
                type="error"
                name="error-file-uploading"
                title={this.state.dialogTitle}
                description={this.state.dialogDescription}
                open={this.state.showDialogError}
                closeHandler={this.handleClose}
                closeButtonText={intl.formatMessage({ id: "popup.button.ok" })}
              />

              {/* ========== POP-UP A (YES/NO CONFIRMATION) ========== */}
              <Dialog
                open={this.state.showPopupA}
                onClose={() => this.setState({ showPopupA: false, pendingAcceptanceFiles: null, pendingEsign: false })}
                maxWidth="sm"
                fullWidth
                sx={{ '& .MuiDialog-container': { alignItems: 'flex-start' } }}
                PaperProps={{ style: { marginTop: '400px' } }}
              >
                <DialogContent>
                  <Typography style={{ marginBottom: "16px" }}>
                    {intl.formatMessage({ id: "popup.policyEffectiveDate.resign.description" })}
                  </Typography>
                  <Typography style={{ marginBottom: "8px", fontWeight: 600 }}>
                    {intl.formatMessage({ id: "popup.policyEffectiveDate.resign.yes" })}
                  </Typography>
                  <Button 
                    onClick={this.handlePopupAYes} 
                    variant="contained" 
                    color="error"
                    size="small"
                    style={{ marginBottom: "16px", borderRadius: "4px", border: "1px solid #333" }}
                  >
                    YES
                  </Button>
                  <Typography style={{ marginBottom: "8px", fontWeight: 600 }}>
                    {intl.formatMessage({ id: "popup.policyEffectiveDate.resign.no" })}
                  </Typography>
                  <Button 
                    onClick={this.handlePopupANo} 
                    variant="contained" 
                    color="error"
                    size="small"
                    style={{ marginBottom: "16px", borderRadius: "4px", border: "1px solid #333" }}
                  >
                    NO
                  </Button>
                  <Typography variant="caption" style={{ display: "block", marginTop: "16px" }} dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: "popup.policyEffectiveDate.passed.note" }) }} />
                </DialogContent>
              </Dialog>

              {/* ========== POP-UP A NO WARNING ========== */}
              <Dialog
                open={this.state.showPopupAWarning}
                onClose={this.handlePopupAWarningDismiss}
                maxWidth="sm"
                fullWidth
              >
                <DialogContent>
                  <Typography style={{ marginBottom: "16px" }}>
                    {intl.formatMessage({ id: "popup.policyEffectiveDate.warning.description" })}
                  </Typography>
                  <Typography style={{ marginBottom: "16px", fontWeight: 600 }}>
                    {intl.formatMessage({ id: "popup.policyEffectiveDate.warning.actions" })}
                  </Typography>
                  <ol style={{ marginBottom: "16px", paddingLeft: 0, marginLeft: 0, listStylePosition: "inside" }}>
                    <li>{intl.formatMessage({ id: "popup.policyEffectiveDate.warning.action1" })}</li>
                    <li>{intl.formatMessage({ id: "popup.policyEffectiveDate.warning.action2" })}</li>
                    <li>{intl.formatMessage({ id: "popup.policyEffectiveDate.warning.action3" })}</li>
                    <li>{intl.formatMessage({ id: "popup.policyEffectiveDate.warning.action4" })}</li>
                  </ol>
                  <Typography style={{ marginBottom: "8px" }}>
                    {intl.formatMessage({ id: "popup.policyEffectiveDate.warning.acknowledge" })}
                  </Typography>
                  <Button 
                    onClick={this.handlePopupAWarningConfirm} 
                    variant="contained" 
                    color="error"
                    size="small"
                    style={{ borderRadius: "4px", border: "1px solid #333" }}
                  >
                    {intl.formatMessage({ id: "popup.policyEffectiveDate.warning.confirm" })}
                  </Button>
                  <Typography variant="caption" style={{ display: "block", marginTop: "16px" }} dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: "popup.policyEffectiveDate.passed.note" }) }} />
                </DialogContent>
              </Dialog>

              {/* ========== POP-UP B (PED HAS PASSED) ========== */}
              <Dialog
                open={this.state.showPopupB}
                onClose={this.handlePopupBDismiss}
                maxWidth="sm"
                fullWidth
              >
                <DialogContent>
                  <Typography style={{ marginBottom: "16px" }}>
                    {intl.formatMessage({ id: "popup.policyEffectiveDate.expired.description" })}
                  </Typography>
                  <Typography style={{ marginBottom: "16px", fontWeight: 600 }}>
                    {intl.formatMessage({ id: "popup.policyEffectiveDate.expired.actions" })}
                  </Typography>
                  <ol style={{ marginBottom: "16px", paddingLeft: 0, marginLeft: 0, listStylePosition: "inside" }}>
                    <li>{intl.formatMessage({ id: "popup.policyEffectiveDate.expired.action1" })}</li>
                    <li>{intl.formatMessage({ id: "popup.policyEffectiveDate.expired.action2" })}</li>
                    <li>{intl.formatMessage({ id: "popup.policyEffectiveDate.expired.action3" })}</li>
                    <li>{intl.formatMessage({ id: "popup.policyEffectiveDate.expired.action4" })}</li>
                  </ol>
                  <Typography style={{ marginBottom: "8px" }}>
                    {intl.formatMessage({ id: "popup.policyEffectiveDate.passed.acknowledge" })}
                  </Typography>
                  <Button
                    onClick={this.handlePopupBDismiss}
                    variant="contained"
                    color="error"
                    size="small"
                    style={{ borderRadius: "4px", border: "1px solid #333" }}
                  >
                    {intl.formatMessage({ id: "popup.policyEffectiveDate.passed.confirm" })}
                  </Button>
                  <Typography
                    variant="caption"
                    style={{ display: "block", marginTop: "16px" }}
                    dangerouslySetInnerHTML={{
                      __html: intl.formatMessage({ id: "popup.policyEffectiveDate.passed.note" })
                    }}
                  />
                </DialogContent>
              </Dialog>

              {/* ========== POP-UP C (DELAYED SUBMISSION) ========== */}
              <Dialog
                open={this.state.showPopupC}
                onClose={this.handlePopupCDismiss}
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle>
                  {intl.formatMessage({ id: "popup.policyEffectiveDate.resign.title" })}
                </DialogTitle>
                <DialogContent>
                  <Typography
                    style={{ marginBottom: "16px" }}
                    dangerouslySetInnerHTML={{
                      __html: intl.formatMessage({ id: "popup.policyEffectiveDate.passed.description" })
                    }}
                  />
                  <Typography style={{ marginBottom: "8px" }}>
                    {intl.formatMessage({ id: "popup.policyEffectiveDate.passed.acknowledge" })}
                  </Typography>
                  <Button 
                    onClick={this.handlePopupCDismiss} 
                    variant="contained" 
                    color="error"
                    size="small"
                    style={{ borderRadius: "4px", border: "1px solid #333" }}
                  >
                    {intl.formatMessage({ id: "popup.policyEffectiveDate.passed.confirm" })}
                  </Button>
                  <Typography
                    variant="caption"
                    style={{ display: "block", marginTop: "16px" }}
                    dangerouslySetInnerHTML={{
                      __html: intl.formatMessage({ id: "popup.policyEffectiveDate.passed.note" })
                    }}
                  />
                </DialogContent>
              </Dialog>
            </div>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  root: {
    width: "100%"
  },
  container: {
    padding: `20px ${theme.spacing.unit * 3}px`
  },
  content: {
    padding: theme.spacing.unit * 3,
    paddingTop: "5px"
  },
  heading: {
    borderBottom: `1px solid ${theme.colors.blackScale.black70}`
  },
  infoHeading: {
    color: `${theme.colors.blackScale.black80}`,
    paddingBottom: 20,
    fontSize: `${theme.infoHeading.fontSize}`
  },
  policyEffectiveDate: {
    fontWeight: 600,
    paddingBottom: 10
  },
  center: {
    display: "flex",
    alignItems: "center"
  },
  hidden: {
    display: "none"
  }
});

function mapStateToProps(state, prop) {
  return { document: state.document, quote: state.quote };
}

function mapDispatchToProps(dispatch) {
  return {
    documentActions: bindActionCreators(documentActions, dispatch),
    quoteActions: bindActionCreators(quoteActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(withStyles(styles, { withTheme: true })(SubmitDoc)));
